import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { ChallengeProgressiveReward, LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Observable } from 'rxjs';
import { NgClass, UpperCasePipe } from '@angular/common';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { BeautifyNumber } from '../../../../pipes/beautify-number.pipe';
import { SharedModule } from '@app/shared/shared.module';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-adventure-quest-reward-box',
  templateUrl: './adventure-quest-reward-box.component.html',
  styleUrls: ['./adventure-quest-reward-box.component.scss'],
  standalone: true,
  imports: [NgClass, DisplayComponent, ButtonComponent, UpperCasePipe, TranslateModule, BeautifyNumber, SharedModule],
})
export class AdventureQuestRewardBoxComponent {
  @Input() event: LimitedTimeEvent;
  @Input() eventChallengeProgressive: ChallengeProgressiveReward;
  @Input() rewardAssetSize: string;
  @Input() isLoading = false;

  @Output() collectReward = new EventEmitter<ChallengeProgressiveReward>();

  componentDestroy: () => Observable<unknown>;

  collectRewardOutput(): void {
    this.collectReward.emit(this.eventChallengeProgressive);
  }
}
